import {ChatServer} from "../chatserver/sx-server";
import {PublisherInterface} from "../publisher/publisher";
import logging from "../utils/log";
import vxServer from "../chatserver/vx-server";

export class CamToCamSnapshots
{
    private TAG = "[Sxc.Chat.CamToCam.Snapshot]";
    private UPDATE_FREQ_MS = 1000;
    private snapshotTimer : number = null;
    private snapshotCounter = 0;

    constructor(private chatServer : ChatServer)
    {

    }

    init(source : PublisherInterface)
    {
        if (this.snapshotTimer) {
            this.cancel();
        }

        // this.sendSnapshot(source.takeSnapshot(70));

        this.snapshotTimer = setInterval(() => {
            let snapshot = source.takeSnapshot(70);
            if (snapshot) {
                this.sendSnapshot(snapshot);
            }

            this.snapshotCounter++;
        }, this.UPDATE_FREQ_MS);
    }

    private sendSnapshot(data)
    {
        logging.log(this.TAG, "sendSnapshot", data ? data.substr(0,100) : data);

        vxServer.sendCam2Cam("image/jpeg;base64," + data);

        if(this.snapshotCounter == 5) {
            this.chatServer.callMethod("uploadSnapshot", {
                    data: data,
                    format: "image/jpeg;base64",
                    asProfilePicture: false,
                    asCam2CamSnapshot: true
                }, (...args) => {
                    // logging.log(this.TAG, "sendSnapshot finished", ...args);
                });

            this.snapshotCounter = 0;
        }
    }

    public clear()
    {
        logging.log(this.TAG, "clear");
        this.sendSnapshot(null);
    }

    public cancel()
    {
        logging.log(this.TAG, "cancel", this.snapshotTimer);
        if (this.snapshotTimer) {
            clearInterval(this.snapshotTimer);
            this.snapshotTimer = null;
        }
    }
}